// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"f041f9053228c0b2","8045":"53e2a3b31477ca62"}[chunkId] + ".css";
};